export default class AttributeMath {
  static calculateMaxHP(level: number, vitality: number) {
    const baseHP = 100;
    const levelAddition = level * 25;
    const vitalityAddition = vitality * 5;
    return baseHP + levelAddition + vitalityAddition;
  }

  static calculateMaxMP(level: number, intelligence: number) {
    const baseMP = 50;
    const levelAddition = level * 10;
    const intelligenceAddition = intelligence * 8;
    return baseMP + levelAddition + intelligenceAddition;
  }

  static calculateManaRegenPerSecond(intelligence: number) {
    const baseRegen = 1;
    const intelRegen = intelligence * 0.5;
    return baseRegen + intelRegen;
  }
}
